"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * expert-queue-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ExpertQueuesApi extends runtime.BaseAPI {
    /**
     */
    addAttributesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling addAttributes.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling addAttributes.');
            }
            if (requestParameters.attributes === null || requestParameters.attributes === undefined) {
                throw new runtime.RequiredError('attributes', 'Required parameter requestParameters.attributes was null or undefined when calling addAttributes.');
            }
            const queryParameters = {};
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/{sessionId}/attributes`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.attributes.map(models_1.QueueItemAttributeToJSON),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    addAttributes(expertId, sessionId, attributes, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addAttributesRaw({ expertId: expertId, sessionId: sessionId, attributes: attributes, correlationId: correlationId });
        });
    }
    /**
     */
    deleteQueueItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling deleteQueueItem.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling deleteQueueItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/{sessionId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteQueueItem(expertId, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteQueueItemRaw({ expertId: expertId, sessionId: sessionId });
        });
    }
    /**
     */
    getRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling get.');
            }
            const queryParameters = {};
            if (requestParameters.maxUnassigned !== undefined) {
                queryParameters['maxUnassigned'] = requestParameters.maxUnassigned;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExpertQueueFromJSON(jsonValue));
        });
    }
    /**
     */
    get(expertId, maxUnassigned) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRaw({ expertId: expertId, maxUnassigned: maxUnassigned });
            return yield response.value();
        });
    }
    /**
     */
    getAssignedItemsCountRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling getAssignedItemsCount.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/assigned/count`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ResultnumberFromJSON(jsonValue));
        });
    }
    /**
     */
    getAssignedItemsCount(expertId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAssignedItemsCountRaw({ expertId: expertId });
            return yield response.value();
        });
    }
    /**
     */
    getQueueItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling getQueueItem.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling getQueueItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/{sessionId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.QueueItemFromJSON(jsonValue));
        });
    }
    /**
     */
    getQueueItem(expertId, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getQueueItemRaw({ expertId: expertId, sessionId: sessionId });
            return yield response.value();
        });
    }
    /**
     */
    getQueueItemAttributesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling getQueueItemAttributes.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling getQueueItemAttributes.');
            }
            const queryParameters = {};
            if (requestParameters.key !== undefined) {
                queryParameters['key'] = requestParameters.key;
            }
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/{sessionId}/attributes`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.QueueItemAttributeFromJSON));
        });
    }
    /**
     */
    getQueueItemAttributes(expertId, sessionId, key, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getQueueItemAttributesRaw({ expertId: expertId, sessionId: sessionId, key: key, type: type });
            return yield response.value();
        });
    }
    /**
     */
    getUnassignedItemsCountRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling getUnassignedItemsCount.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/unassigned/count`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ResultnumberFromJSON(jsonValue));
        });
    }
    /**
     */
    getUnassignedItemsCount(expertId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUnassignedItemsCountRaw({ expertId: expertId });
            return yield response.value();
        });
    }
    /**
     */
    removeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling remove.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    remove(expertId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeRaw({ expertId: expertId });
        });
    }
    /**
     */
    removeAttributeByCustomerRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling removeAttributeByCustomer.');
            }
            if (requestParameters.request === null || requestParameters.request === undefined) {
                throw new runtime.RequiredError('request', 'Required parameter requestParameters.request was null or undefined when calling removeAttributeByCustomer.');
            }
            const queryParameters = {};
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{customerId}/attributes/remove`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseRemoveAttributeByCustomerToJSON(requestParameters.request),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    removeAttributeByCustomer(customerId, request, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeAttributeByCustomerRaw({ customerId: customerId, request: request, correlationId: correlationId });
        });
    }
    /**
     */
    removeAttributesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling removeAttributes.');
            }
            if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
                throw new runtime.RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling removeAttributes.');
            }
            if (requestParameters.attributesIdentifier === null || requestParameters.attributesIdentifier === undefined) {
                throw new runtime.RequiredError('attributesIdentifier', 'Required parameter requestParameters.attributesIdentifier was null or undefined when calling removeAttributes.');
            }
            const queryParameters = {};
            if (requestParameters.correlationId !== undefined) {
                queryParameters['correlationId'] = requestParameters.correlationId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items/{sessionId}/attributes/remove`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))).replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.AttributesIdentifierToJSON(requestParameters.attributesIdentifier),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RemoveAttributeResultFromJSON(jsonValue));
        });
    }
    /**
     */
    removeAttributes(expertId, sessionId, attributesIdentifier, correlationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.removeAttributesRaw({ expertId: expertId, sessionId: sessionId, attributesIdentifier: attributesIdentifier, correlationId: correlationId });
            return yield response.value();
        });
    }
    /**
     */
    removeItemsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.expertId === null || requestParameters.expertId === undefined) {
                throw new runtime.RequiredError('expertId', 'Required parameter requestParameters.expertId was null or undefined when calling removeItems.');
            }
            if (requestParameters.request === null || requestParameters.request === undefined) {
                throw new runtime.RequiredError('request', 'Required parameter requestParameters.request was null or undefined when calling removeItems.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/{expertId}/items`.replace(`{${"expertId"}}`, encodeURIComponent(String(requestParameters.expertId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseRemoveItemsOptionsToJSON(requestParameters.request),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    removeItems(expertId, request) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeItemsRaw({ expertId: expertId, request: request });
        });
    }
    /**
     */
    removeSessionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.request === null || requestParameters.request === undefined) {
                throw new runtime.RequiredError('request', 'Required parameter requestParameters.request was null or undefined when calling removeSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/items/remove`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseRemoveSessionOptionsToJSON(requestParameters.request),
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    removeSession(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.removeSessionRaw({ request: request });
            return yield response.value();
        });
    }
    /**
     */
    upsertQueueItemsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.request === null || requestParameters.request === undefined) {
                throw new runtime.RequiredError('request', 'Required parameter requestParameters.request was null or undefined when calling upsertQueueItems.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("aad-issuer", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/expertQueues/upsert/items`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RequestBaseSessionUpsertToJSON(requestParameters.request),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    upsertQueueItems(request) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.upsertQueueItemsRaw({ request: request });
        });
    }
}
exports.ExpertQueuesApi = ExpertQueuesApi;
